
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import AppHeaderV2 from '@/components/common/AppHeaderV2';
import Body from './Body';
import BodyPc from './BodyPc';
import PaginatedReviewResourceView from '@/mixins/PaginatedReviewResourceView';

export default {
  i18nComponentKey: 'WidgetProductReviewsListV3.components.ListV3',
  name: 'ListV3',
  components: {
    AppHeaderV2,
    Body,
    BodyPc
  },
  mixins: [PaginatedReviewResourceView],
  computed: {
    ...mapGetters('widget', [
      'isMobileViewport',
      'appHeaderV2AndTitleShowable'
    ]),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapGetters('reviewSettings', ['isAuthorDisplayTypeUserGrade']),
    defaultResourceParams() {
      return {
        fields: [
          'has_media',
          'total_product_media_reviews_count',
          'reviews.evaluation_properties',
          'reviews.ai_summary',
          'reviews.with_parent_reviews',
          'reviews.customer_properties',
          this.reviewSettings.use_comments &&
          this.reviewSettings.always_show_comments
            ? 'reviews.comments'
            : '',
          this.isAuthorDisplayTypeUserGrade ? 'reviews.brand_user_grade' : '',
          this.widget.use_review_keyword_filter
            ? 'reviews.message_with_highlight'
            : '',
          this.widget.show_review_ask ? 'product_meta_reviews_count' : '',
          this.widget.show_review_ask ? 'product_id' : ''
        ]
          .filter(v => v)
          .join(',')
      };
    }
  },
  created() {
    if (this.widget.use_review_write_button) this.fetchReviewWritableCheck();
    this.SET_EDIT_OR_DELETE_CALLBACK(() => this.refreshReviews());
  },
  beforeDestroy() {
    this.SET_EDIT_OR_DELETE_CALLBACK(null);
  },
  methods: {
    ...mapActions('review', ['fetchReviewWritableCheck']),
    ...mapActions('widget', ['openShowReviewPopup']),
    ...mapMutations('review', ['SET_EDIT_OR_DELETE_CALLBACK']),
    refreshReviews() {
      this.searchResource();
      if (this.widget.show_product_score) {
        this.fetchProductScoreSummary({ fields: 'scores_map' });
      }
    },
    submit(params) {
      this.searchResource(params);
    }
  }
};
